const config = require('./config.yaml');
const tooltipTemplate = require('./template.ejs');
const CAutoDict = require('../../index.js');

/**
 * Реализует логику варианта base компонента auto-dict
 */
class CAutoDict_base extends CAutoDict {
	constructor() {
		super();
		this.config = config;
		this.tooltipTemplate = tooltipTemplate;
	}

	/**
	 * Инициализация
	 */
	init() {
		// по загрузке документа
		$(document).ready(() => {
			// простановка тултипов
			this.placeTooltips();
		});
	}

	/**
	 * Создание тултипов
	 * @param {string} regex регулярное выражение
	 * @param {string} description описание
	 * @param {string} elementText текст элемента
	 */
	doTooltip(regex, description, elementText) {
		// переменная с регуляркой
		let regexp = new RegExp('(?!<\\w+?\\s+?class=\\"[^<]*tooltip.*?\\">)(' + regex + ')(?!(<\/\\w+>)+)', 'i');
		// наличие текстового содержимого элемента
		let isExists = regexp.test(elementText);
		// проверка существования
		if (isExists) {
			// подмена контента на тултип
			return elementText.replace(regexp, (match) => {
				// тултип из конфига
				return this.tooltipTemplate({match, description, config});
			});
		} else {
			return elementText;
		}
	}

	/**
	 * Добавить тултипы
	 */
	placeTooltips() {
		const $container = $(config.container);

		if ($container.length) {
			this.terms = this.config.terms[templateVars.lang];
			this.updateDom($container);
			this.initTooltips();
		}
	}

	/**
	 * Инициализация добавленных тултипов
	 */
	initTooltips() {
		const $elementsForTooltip = $('.b-tooltip.b-tooltip--need-create');

		if ($elementsForTooltip.length) {
			AR
				.components
				.cTooltips_base
				.createTooltips($elementsForTooltip.removeClass('b-tooltip--need-create'));

			AR.events.emit('onRebuildSup');
		}
	}

	/**
	 * Обновление дома
	 * @param {object} $element контентная область
	 */
	updateDom($element) {
		let $childs = $element.contents();

		$childs.each((index, element) => {
			if (element.nodeType === 3) {
				// если нет текста
				if (element.textContent.trim().length == 0) {
					return;
				}

				const textWithTooltips = this.terms.reduce((result, current) => {
					return this.doTooltip(current.term, current.description, result);
				}, element.textContent);


				if (textWithTooltips) {
					$(element).replaceWith(textWithTooltips);
				}
			} else {
				this.updateDom($(element));
			}
		});
	}

}

AR.waitComponents([], () => {
	const cAutoDict_base = new CAutoDict_base();
	// Вызов метода, инициализирующего все существующие события
	cAutoDict_base.init();
	// Добавление в глобальный объект AR.components
	AR.pushComponent(cAutoDict_base, 'cAutoDict_base');
});



// WEBPACK FOOTER //
// ./temp/components/auto-dict/.variant/base/index.js